export const getContainerStyles = (isQuestionnaire: boolean) => {
  return {
    padding: `2rem ${isQuestionnaire ? "0" : "1.25rem"}`,
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    overflowY: isQuestionnaire ? "hidden" : "auto",
    paddingTop: "94px",
  };
};

export const getMainStyles = (isQuestionnaire: boolean) => {
  return {
    flexWrap: "nowrap",
    maxWidth: "689px",
    height: "100%",
    padding: `0 ${isQuestionnaire ? "1.25rem" : "0"}`,
  };
};
